import { Box, Button, Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useContext, useEffect, useState } from "react";
import clsx from "clsx";
import AppConstants from "../../common/AppConstants";
import ProfileSubmitValidations from "../../screens/coachProfileEdit/ProfileSubmitValidations";
import { coachProfileService } from "../../services";
import SnackbarMsg from "../Snackbar/Snackbar";
import EditProfileValidationDialog from "../dialog/EditProfileValidationDialog";
import ProfileSummary from "../profileSummary/ProfileSummary";
import { darkenColor } from "../../utils/appHelper";
import { UserProfileContext } from "../../common/ProfileContext";

const useStyles = makeStyles((theme) => ({
    profileSummary: {
        paddingBottom: theme.spacing(2),
        minHeight: "300px",
        boxShadow: '0px 0px 5px rgba(6, 37, 91, .2)',
        borderRadius: '0',
        backgroundColor: theme.palette.mode === 'dark' ? darkenColor(theme.palette.background.default, 25) : theme.palette.primary.dark
    },
    submitButton: {
        alignContent: "center",
        textAlign: "center",
        paddingBottom: 10,
        paddingRight: 10,
    },
}));

/**
 * Reusable Coach Profile Summary Component
 * Works with both UserProfileContext and AdminCoachProfileContext
 * @param {Object} props - Component props
 * @param {boolean} props.isViewMode - Whether component is in view mode (displays submit button)
 * @param {boolean} props.showBackButton - Optional: Show back button in profile summary
 */
const CoachProfileSummary = ({ isViewMode = false, showBackButton = false }) => {
    const classes = useStyles();
    const contextValue = useContext(UserProfileContext);
    const {
        profilePhoto,
        profileVideo,
        status,
        fullName,
        userName,
        roleAndCoachingPhilosophy,
        mediaAndArticle,
        coachingVideos,
        jwtTokenDetails,
        profileCompleteness,
        remainingSection,
        updateStatus,
        coachingExperience,
        other,
        additionalExperience,
        skillSet,
        educationDetail,
        coachingAndOtherJobExperience,
        playingExperience,
        lastModifiedAt,
        profile,
        profileVideos,
        profileViewCount,
    } = contextValue;

    const [statusState, setStatusState] = useState(status);
    const [btnSubmit, setBtnSubmit] = useState(true);
    const [showMsg, setShowMsg] = useState(false);
    const [validationDialogOpen, setValidationDialogOpen] = useState(false);
    const [validationMessageList, setValidationMessageList] = useState([]);

    const handleTermsandCondition = (event) => {
        if (event.target.checked) {
            setBtnSubmit(false);
        } else {
            setBtnSubmit(true);
        }
    };

    const handleSubmitClick = () => {
        let validationMessage = [];
        validationMessage = ProfileSubmitValidations.ValidateProfile(
            fullName,
            roleAndCoachingPhilosophy,
            profilePhoto,
            profileVideo,
            mediaAndArticle,
            coachingVideos,
            coachingExperience,
            other,
            additionalExperience,
            skillSet,
            educationDetail,
            coachingAndOtherJobExperience,
            playingExperience
        );

        if (validationMessage.length == 0) {
            coachProfileService.submitProfile().then((status) => {
                setShowMsg(true);
                updateStatus && updateStatus(AppConstants.PROFILE_STATUS.SUBMITTED);
                setStatusState(AppConstants.PROFILE_STATUS.SUBMITTED);
            });
        } else {
            setValidationDialogOpen(true);
            setValidationMessageList(validationMessage);
        }
    };

    useEffect(() => {
        setStatusState(status);
    }, [status]);

    return (
        <>
            <Paper className={clsx(classes.profileSummary, "custom-view")}>
                <ProfileSummary
                    profilePhoto={profilePhoto}
                    profileVideos={profileVideos}
                    profileVideo={profileVideo}
                    fullName={fullName}
                    userName={userName}
                    roleAndCoachingPhilosophy={roleAndCoachingPhilosophy}
                    mediaAndArticle={mediaAndArticle}
                    coachingVideos={coachingVideos}
                    jwtTokenDetails={jwtTokenDetails}
                    profileCompleteness={profileCompleteness}
                    remainingSection={remainingSection}
                    profileStatus={status}
                    lastModifiedAt={lastModifiedAt}
                    profileViewCount={profileViewCount}
                    isViewMode={isViewMode}
                    showBackButton={showBackButton}
                    isCoachProfile={true}
                    profile={profile}
                />
            </Paper>

            {isViewMode && (
                <div>
                    {statusState &&
                        (statusState == AppConstants.PROFILE_STATUS.REGISTERED ||
                            statusState == AppConstants.PROFILE_STATUS.DENIED) && (
                            <Grid
                                container
                                style={{ paddingTop: "10px" }}
                                className={classes.submitButton}
                            >
                                <Grid size={{ xs: 12, md: 12 }}></Grid>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Button
                                        onClick={handleSubmitClick}
                                        color="primary"
                                        variant="contained"
                                    >
                                        Submit Profile
                                    </Button>
                                </Grid>
                            </Grid>
                        )}

                    <SnackbarMsg
                        showError={showMsg}
                        onClose={() => setShowMsg(false)}
                        severity="success"
                        msg="Thank you for submitting your profile."
                    />

                    <EditProfileValidationDialog
                        validationMessageList={validationMessageList}
                        validationDialogOpen={validationDialogOpen}
                        onClose={() => setValidationDialogOpen(false)}
                    />
                </div>
            )}
        </>
    );
};

export default CoachProfileSummary;
